import React from "react";
import { useIsMobile } from "../hooks/use-is-mobile";

/** Renders children only on tablet/desktop widths. */
export const DesktopOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isMobile = useIsMobile();
  return isMobile ? null : <>{children}</>;
};

/** Renders children only on phone widths. */
export const MobileOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isMobile = useIsMobile();
  return isMobile ? <>{children}</> : null;
};
